import * as yup from 'yup';
import { sharedAigFields } from '../shared/sharedAigSchema';

export const bikeAigSchemaBuilder = (
    firstDriverAdditionalPremiumAge,
    secondDriverAdditionalPremiumAge,
    firstDriverAdditionalPremiumLicenseYears,
    secondDriverAdditionalPremiumLicenseYears,
    legalEntity,
    secondDriver,
    discountEntity,
    vehicleType
) => yup.object({
    ...sharedAigFields(
        firstDriverAdditionalPremiumAge,
        secondDriverAdditionalPremiumAge,
        firstDriverAdditionalPremiumLicenseYears,
        secondDriverAdditionalPremiumLicenseYears,
        legalEntity,
        secondDriver,
        discountEntity,
        vehicleType
    ),
});

export default bikeAigSchemaBuilder;
